import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/insertLogApiRest';

const api = axios.create({
    baseURL: baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const insertLogApiRest = async (data, ruta) => {
    try {
        const response = await api.post(orgEndpointInsert, {
            body: data,  // 🔹 Anidamos los datos dentro de "body" como espera el backend
            rutaService: ruta,
        }, {
            headers: {
                'Content-Type': 'application/json',  // 🔹 Especificamos el tipo de contenido JSON
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error al crear el log de API:', error);
        throw error;
    }
};
